 
import React, { Component } from "react";
import axios from "axios";

import {
  Box,
  Paper,
  Grid,
  Typography,
  TextField,
  Button,
  MenuItem
} from "@mui/material";

import API_URL from "./Apiurl";

class Admincms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      adminoptions: [],
      ao_id: "0",
      ao_name: "",
      ao_value: "",

     
    };
  }

  componentWillMount() {
	  
	  if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
	  let strname="Parameters";   
			 this.props.parentsCallback(
           strname
        );
    this.loadAdminOptions();
  }

  loadAdminOptions = () => {
    axios
      .get(API_URL + "ajaxadminoption.php", {
        params: {
          action: "getall"
        }
      })
      .then((res) => {
        this.setState({
          adminoptions: res.data || []
        });
      });
  };

  handleDropdownChange = (event) => {
    const ao_id = event.target.value;


axios.get(API_URL + "ajaxadminoption.php", {
        params: {
          action: "getall",
		  ao_id:ao_id
        }
      })
      .then((res) => {
        this.setState({
         ao_id: res.data[0].ao_id,

        ao_value: res.data[0].ao_value,
      
        });
      });

  
  };

  updateData = () => {
    let formData = new FormData();

    formData.append("action", "update");
    formData.append("ao_id", this.state.ao_id);

    formData.append("ao_value", this.state.ao_value);
   
    formData.append("userid", localStorage.getItem("VRuserid"));

    axios
      .post(API_URL + "ajaxadminoption.php", formData)
      .then(() => {
        alert("Updated Successfully");
        this.loadAdminOptions();
      });
  };

  render() {
    return (
    
    
  
  <div className="changepassword">
  

          
              <p>
                Select Option
       </p>
<p>
              <TextField
                select
                fullWidth
                size="small"
                value={this.state.ao_id}
                onChange={this.handleDropdownChange}
              >
			   <MenuItem
                    key={0}
                    value={0}
                  >
                    Select
                  </MenuItem>
                {this.state.adminoptions.map((row) => (
                  <MenuItem
                    key={row.ao_id}
                    value={row.ao_id}
                  >
                    {row.ao_name}
                  </MenuItem>
                ))}
              </TextField>
          </p>

                <p>
                Value
                   </p>
   <p>
              Rs.<TextField
                fullWidth
                size="small"
                value={this.state.ao_value}
                onChange={(e) =>
                  this.setState({
                    ao_value: e.target.value
                  })
                }
              />
           </p>

               <p>
              <Button
                variant="contained"
                onClick={this.updateData}
              >
                Submit
              </Button>     </p>
       </div>

    );
  }
}

export default Admincms;
 
